import axios from 'axios'

const endPoint = "user"

// Update profile function
export function updateProfile({ state, rootState }) {

    var isStudent = rootState.auth.authUser.roles.filter((role) => { return role.name == 'Student' }).length

    state.editItem.mob_no = `${state.editItem.std_code} ${state.editItem.mob_no}`
    let editItem = state.editItem;

    var user = Object.assign({}, editItem);
    user.role_name = isStudent ? 'Student' : 'Teacher'

    return new Promise((resolve, reject) => {
        axios
            .put(endPoint + "/" + editItem._id, editItem)
            .then(response => {
                this.dispatch('auth/fetchAuthUser')
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}


// Update profile function
export function updatePassword({ state }, props) {

    return new Promise((resolve, reject) => {
        axios
            .post(endPoint + "/updatepassword", {
                old_password: props.old_password,
                new_password: props.password,
                confirm_password: props.password
            })
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

// Update profile function
export function updateProfileImage({ state, rootState }, formData) {

    return new Promise((resolve, reject) => {
        axios
            .post(endPoint + "/changeProfileImage/" + rootState.auth.authUser._id, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            })
            .then(response => {
                this.dispatch('auth/fetchAuthUser')
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function addInterest({ state, rootState }, formData) {

    return new Promise((resolve, reject) => {
        axios
            .post(endPoint + "/interests", formData)
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function getInterests({ commit }, id) {

    return new Promise((resolve, reject) => {
        axios
            .get(`${endPoint}/${id}`)
            .then(response => {
                commit('setInterests', response.data.data.interests)
                resolve(response.data.data.interests)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function removeInterest({ commit, state }, formData) {

    return new Promise((resolve, reject) => {
        axios
            .delete(`${endPoint}/interests/${formData.interest_id}/${state.editItem._id}`)
            .then(response => {
                resolve(response.data.data.interests)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function searchInterests({ commit, state }, search) {

    return new Promise((resolve, reject) => {
        axios
            .post(`/search/interests`, { 'search': search })
            .then(response => {
                resolve(response.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function deleteAccount({ commit, state }, search) {

  return new Promise((resolve, reject) => {
      axios
          .delete(`/user/delete`)
          .then(response => {
              resolve(response.data)
          })
          .catch(err => {
              reject(err)
          })
  })
}

export function getSettings({ commit, state, rootState }) {

    return new Promise((resolve, reject) => {
        axios
            .get(`/user/${rootState.auth.authUser._id}/settings`)
            .then(response => {
                resolve(response.data.data)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function updateSettings({ commit, state, rootState }, property) {

      return new Promise((resolve, reject) => {
          axios
              .post(`/user/${rootState.auth.authUser._id}/settings`, property)
              .then(response => {
                  resolve(response.data)
              })
              .catch(err => {
                  reject(err)
              })
      })
}

export function resetStore({ commit, store }) {
    commit('resetStore')
}
